import Agreement from './Agreement';
import AnnualContractDiscount from './AnnualContractDiscount';
import MobileAppProduct from './MobileAppProduct';
import PaymentInfo from './PaymentInfo';
import PaymentMethodForm from './PaymentMethodForm';
import Subscription from './Subscription';
import SubscriptionProduct from './SubscriptionProduct';
import SubscriptionTags from './SubscriptionTags';

export default {
  Agreement,
  AnnualContractDiscount,
  MobileAppProduct,
  PaymentInfo,
  PaymentMethodForm,
  Subscription,
  SubscriptionProduct,
  SubscriptionTags,
};
